import React from 'react';
import styled from 'styled-components'
import { SkeletonLine } from './skeleton'

const FiveWins = (props) => {


    /*
      const stats = {
        conversionRate,
        biggestWin,
        biggestLoss,
        averageDealSizeWon,
      };
    
    */

    // format currency $ no decimal places, no currency country code
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });

    const formatDollars = (dollars) => {
        return formatter.format(dollars);
    }

    function formatDateShort(dateString) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const date = new Date(dateString);

        const day = date.getDate();
        const monthIndex = date.getMonth();
        const month = months[monthIndex];

        return `${day}-${month}`;
    }


    const loading = props.loading || !props.data;

    let wins = loading ? (
        <>
            {Array.from({ length: 5 }).map((_, i) => (
                <Row key={`w-skel-${i}`}>
                    <SkeletonLine $w="48px" $h="16px" />
                    <SkeletonLine $w="60%" $h="16px" />
                    <SkeletonLine $w="80px" $h="16px" />
                </Row>
            ))}
        </>
    ) : <Name>No data available</Name>;
    if (!loading && props.data.lastFiveWins.length > 0) {
        wins = props.data.lastFiveWins.map((win) => {
            return <Row key={win.dealname}>
                <DateField>{formatDateShort(win.closedate)}</DateField>
                <Name>{win.dealname}</Name>
                <Amount>{formatDollars(win.amount)}</Amount>
            </Row>
        });
    }

    let losses = loading ? (
        <>
            {Array.from({ length: 5 }).map((_, i) => (
                <Row key={`l-skel-${i}`}>
                    <SkeletonLine $w="48px" $h="16px" />
                    <SkeletonLine $w="60%" $h="16px" />
                    <SkeletonLine $w="80px" $h="16px" />
                </Row>
            ))}
        </>
    ) : <Name>No data available</Name>;
    if (!loading && props.data.lastFiveLosses.length > 0) {
        losses = props.data.lastFiveLosses.map((loss) => {
            return <Row key={loss.dealname}>
                <DateField>{formatDateShort(loss.closedate)}</DateField>
                <Name>{loss.dealname}</Name>
                <Amount>{formatDollars(loss.amount)}</Amount>
            </Row>
        });
    }


    return (<Container>
        <Card>
            <Header>
                <Title>Last 5 Wins</Title>
                <Badge $positive>▲</Badge>
            </Header>
            <List>{wins}</List>
        </Card>
        <Card>
            <Header>
                <Title>Last 5 Losses</Title>
                <Badge $negative>▼</Badge>
            </Header>
            <List>{losses}</List>
        </Card>
    </Container>)
}

export default FiveWins;


const Container = styled.div`
    display: flex;
    flex-wrap: nowrap; /* This ensures that the divs stay in one line */
    justify-content: space-between; /* Optional: Add space between divs */
    column-gap: 20px;
    margin-bottom: 60px;
    margin-top: 0px;

    @media (max-width: 768px) {
        flex-wrap: wrap; 
    }

`;

// display: flex;
// flex-wrap: nowrap; /* This ensures that the divs stay in one line */
// justify-content: space-between; /* Optional: Add space between divs */
// column-gap: 20px;
// margin-bottom: 60px;
// margin-top: 40px;

// @media (max-width: 768px) {
//     flex-wrap: wrap; 
// }


const List = styled.div``;

const Row = styled.div`
    display: grid;
    grid-template-columns: 64px 1fr auto;
    align-items: center;
    gap: 16px;
    padding: 12px 14px;
    border-radius: 10px;
    background: rgba(255,255,255,0.7);
    border: 1px solid #e9edf3;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    &:not(:last-child) { margin-bottom: 10px; }
`;




const Title = styled.h2`
    font-size: 1rem;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: #8A94A6;
    margin: 0;
`;

const DateField = styled.div`
    font-size: 0.95rem;
    color: #3b4048;
    width: 64px;
    text-align: left;
`;

const Name = styled.div`
    font-size: 1rem;
    color: #0b1220;
`;

const Amount = styled.div`
    font-size: 1rem;
    color: #0b1220;
    min-width: 110px;
    text-align: right;
`;


// const Note = styled.p`
//     font-size: .8rem;
//     text-align: center;
//     color:  #AAAAAA;
//     margin: 0;
// `;


const Card = styled.div` 
    flex: 1;
    border-radius: 12px;
    background: rgba(255,255,255,0.75);
    border: 1px solid #e9edf3;
    box-shadow: 0 6px 18px rgba(0,0,0,0.12);
    backdrop-filter: blur(6px);
    padding: 16px 16px 22px 16px;

    @media (max-width: 768px) {
        flex-basis: calc(50% - 20px);
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`;

const Badge = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    font-weight: 700;
    color: #334155;
    background: #EEF2FF;
    ${props => props.$positive && `background:#EEF7F0; color:#1f7a3f;`}
    ${props => props.$negative && `background:#FFF1F1; color:#b42318;`}
`;

